import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../translate/index'; // our translate service



export class TranslatePipe implements PipeTransform {

    constructor(private _translate: TranslateService) { }

    transform(value: string, args: any[]): any {
        if (!value) return;

        return this._translate.instant(value);
    }
static ctorParameters() { return [ { type: TranslateService } ]; }}


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../watchuslive/translate/translate.pipe.ts